import React from 'react';

const AppointmentShortList = ({appointments}) => {
    return (
        <table className='w-100 text-center'>
                <thead>
                    <tr>
                        <th className='p-2 text-start'>Name</th>
                        <th className='p-2'>Phone</th>
                        <th className='p-2'>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        appointments.map(user => 
                            
                            <tr key={user._id}>
                                <td className='p-2 text-start'>{user.name}</td>
                                <td className='p-2'>{user.phone}</td>
                                <td className='p-2'>{user.email}</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
    );
};

export default AppointmentShortList;